import { render } from "./FuturePage.vue?vue&type=template&id=7ea5f586&scoped=true"
import script from "./FuturePage.vue?vue&type=script&lang=js"
export * from "./FuturePage.vue?vue&type=script&lang=js"

import "./FuturePage.vue?vue&type=style&index=0&id=7ea5f586&scoped=true&lang=css"

import exportComponent from "D:\\a\\utslappstoppen\\utslappstoppen\\utslappstoppen.app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea5f586"]])

export default __exports__